/*
 *    Copyright (c) 2018-2025, insuranceagent All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: insuranceagent
 */

import request from '@/router/axios'

/*
 *  渠道指标 数据分析
 */

//
export function channelDmIndex(query) {
	return request({
		url: '/dist/channelDm/index',
		method: 'get',
		params: query,
	})
}

//查询渠道汇总数据
export function channelDmSummary(query) {
	return request({
		url: '/dist/channelDm/summary',
		method: 'get',
		params: query,
	})
}

//查询 日列表
export function channelDayList(query) {
	return request({
		url: '/dist/channelDm/dayList',
		method: 'get',
		params: query,
	})
}

//查询 月列表
export function channelMonthList(query) {
	return request({
		url: '/dist/channelDm/monthList',
		method: 'get',
		params: query,
	})
}
